import React, { useState } from "react";
import { Table, Button, Modal, Form, Input, Checkbox } from "antd";

const RoleManagement = ({ roles, resources, onAddRole, onEditRole, onDeleteRole }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [roleForm] = Form.useForm();

  // Open the modal for adding or editing roles
  const showModal = (role = null) => {
    setEditingRole(role);
    if (role) {
      // Populate form with role data for editing
      roleForm.setFieldsValue({
        roleName: role.roleName,
        roleDescription: role.roleDescription,
        permissions: role.  permissions.reduce((acc, perm) => {
          acc[perm.resource] = perm.actions;
          return acc;
        }, {}),
      });
    } else {
      roleForm.resetFields();
    }
    setIsModalVisible(true);
  };

  const handleFinish = (values) => {
    const formattedPermissions = Object.entries(values.permissions || {}).map(
      ([resource, actions]) => ({ resource, actions })
    );
    const roleData = {
      ...values,
      permissions: formattedPermissions,
    };

    if (editingRole) {
      onEditRole(editingRole._id, roleData);
    } else {
      onAddRole(roleData);
    }

    setIsModalVisible(false);
  };

  const handleDelete = (roleId) => {
    onDeleteRole(roleId);
  };

  const columns = [
    {
      title: "Role Name",
      dataIndex: "roleName",
      key: "roleName",
    },
    {
      title: "Description",
      dataIndex: "roleDescription",
      key: "roleDescription",
    },
    {
      title: "Permissions",
      key: "permissions",
      render: (_, record) => (
        <ul>
          {record.permissions.map((perm) => (
            <li key={perm.resource}>
              <strong>{perm.resource}:</strong> {perm.actions?perm.actions.join(", "): "-"}
            </li>
          ))}
        </ul>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => showModal(record)}>
            Edit
          </Button>
          <Button type="link" danger onClick={() => handleDelete(record._id)}>
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div>
      <Button type="primary" onClick={() => showModal()} style={{ display:"flex", marginBottom: "16px",justifyContent:"left" }}>
        Add Role
      </Button>
      <Table columns={columns} dataSource={roles} rowKey="_id" />

      <Modal
        title={editingRole ? "Edit Role" : "Add Role"}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <Form form={roleForm} layout="vertical" onFinish={handleFinish}>
          <Form.Item
            name="roleName"
            label="Role Name"
            rules={[{ required: true, message: "Please enter the role name" }]}
          >
            <Input placeholder="Enter role name" />
          </Form.Item>

          <Form.Item
            name="roleDescription"
            label="Role Description"
            rules={[{ required: true, message: "Please enter a description" }]}
          >
            <Input.TextArea placeholder="Enter role description" rows={4} />
          </Form.Item>

          <Form.Item label="Permissions" name="permissions">
            {resources.map((resource) => (
              <div key={resource} style={{ marginBottom: "16px" }}>
                <h4>{resource}</h4>
                <Form.Item
                  name={["permissions", resource]}
                  valuePropName="checked"
                  initialValue={[]}
                  style={{ margin: 0 }}
                >
                  <Checkbox.Group
                    options={[
                      { label: "View", value: "View" },
                      { label: "Edit", value: "Edit" },
                      { label: "Create", value: "Create" },
                      { label: "Delete", value: "Delete" },
                    ]}
                  />
                </Form.Item>
              </div>
            ))}
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {editingRole ? "Save Changes" : "Add Role"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default RoleManagement;
